import { Button } from "react-materialize";
import { useUserDataContext } from '../contexts/userDataProvider';
import { logOutUrl } from './common/utils';

const NotActivated = () => {
  const { translate } = useUserDataContext();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
    padding: '0 20px'
  };

  const backButton = {
    marginTop: 60
  };

  return (
    <div style={containerStyle}>
      <h3>{translate('pageDoesNotExist')}</h3>
      <Button
        style={backButton}
        node="button"
        type="submit"
        waves="light"
        onClick={() => {
          window.location.href = logOutUrl;
        }}
      >
        {translate('backToLoginPage')}
      </Button>
    </div>
  );
};

export default NotActivated;
